import defectCategoryReducer from './reducers'

export { default as defectCategorySelectors } from './selectors'
export { default as defectCategoryActions } from './actions'
export { default as defectCategoryTypes } from './actionTypes'

export default defectCategoryReducer
